import { OAuthToVerificationType } from '../OAuthMapping';
export const getOAuthVerificationType = provider => {
  return OAuthToVerificationType[provider];
};